import React from 'react';

const EMarketing = () => {
    return (
        <div>
            <h1>EMarketing page</h1>
        </div>
    );
}

export default EMarketing;
